/* flag.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3zvHkHdC7N%7Boverflow-wrap%3Aanywhere%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._23rrnHgHsw%7Btransition%3Abackground-color%20.2s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42Yu6BbFo4%7Bz-index%3A600%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kOSYtpwtV%7Btransition-property%3Agap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3Z9K0wqvoi%7Btransition-duration%3Avar(--ds-duration-long%2C.25s)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(prefers-reduced-motion%3Areduce)%7B._2Iz54kUiLg%7Btransition-duration%3A0s%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIoWWg%7Bmin-width%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4kiQYAoWWg%7Bmin-height%3A24px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._37wbyuDIqT%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzGdh0%7Bcolor%3Avar(--flag-icon-color)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._23rrnHoCc6%7Btransition%3Agap%20.3s%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2sNsIgmnOE%7Bfont%3Avar(--ds-font-body%2Cnormal%20400%2014px%2F20px%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAIZbP%7Boverflow-x%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGIZbP%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0NUa3rQEt6%7Bmax-height%3A75pt%7D");
import { type CSSProperties, type FC, useCallback, useEffect, useState } from 'react';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import noop from '@atlaskit/ds-lib/noop';
import Heading from '@atlaskit/heading/heading';
import MotionPresenceBoundary from '@atlaskit/motion/motion-presence-boundary';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';
import { DEFAULT_APPEARANCE } from './constants';
import Actions from './flag-actions';
import { flagBackgroundColor } from './flag-background-color';
import { flagIconColor } from './flag-icon-color';
import { flagIconGlyph } from './flag-icon-glyph';
import { flagTextColor } from './flag-text-color';
import { flagTextColorToken } from './flag-text-color-token';
import { default as DismissButton } from './internal/dismiss-button';
import { default as Expander } from './internal/expander';
import { useFlagGroup } from './internal/use-flag-group';
import type { FlagProps } from './types';
const styles = {
  overflowWrap: "_3zvHkHdC7N",
  flag: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _23rrnHgHsw _2OUyjtGk8v _42Yu6BbFo4 _39xV02N91d",
  contentStack: "_1kOSYtpwtV _3Z9K0wqvoi _2Iz54kUiLg"
};
const CSS_VAR_ICON_COLOR = '--flag-icon-color';
const descriptionStyles = null;
const flagWrapperStyles = null;
const iconWrapperStyles = null;
const transitionStyles = null;
const analyticsAttributes = {
  componentName: 'flag',
  packageName: (process.env._PACKAGE_NAME_ as string),
  packageVersion: (process.env._PACKAGE_VERSION_ as string)
};

/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */
const Flag: FC<FlagProps> = props => {
  const {
    actions = [],
    appearance = DEFAULT_APPEARANCE,
    icon,
    title,
    description,
    linkComponent,
    onMouseOver,
    onFocus = noop,
    onMouseOut,
    onBlur = noop,
    onDismissed: onDismissedProp = noop,
    testId,
    id,
    analyticsContext,
    delayAnnouncement,
    headingLevel = 2
  } = props;
  const [isDelayToAnnounce, setIsDelayToAnnounce] = useState(false);
  const {
    onDismissed: onDismissedFromFlagGroup,
    isDismissAllowed
  } = useFlagGroup();
  const onDismissed = useCallback((id: string | number, analyticsEvent: UIAnalyticsEvent) => {
    onDismissedProp(id, analyticsEvent);
    onDismissedFromFlagGroup(id, analyticsEvent);
  }, [onDismissedProp, onDismissedFromFlagGroup]);
  const [isExpanded, setIsExpanded] = useState(false);
  const onDismissedAnalytics = usePlatformLeafEventHandler({
    fn: onDismissed,
    action: 'dismissed',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  const isBold = appearance !== DEFAULT_APPEARANCE;
  const toggleExpand = useCallback(() => {
    setIsExpanded(previous => !previous);
  }, []);
  const buttonActionCallback = useCallback(() => {
    if (isDismissAllowed) {
      onDismissedAnalytics(id);
    }
  }, [onDismissedAnalytics, id, isDismissAllowed]);
  useEffect(() => {
    // If buttons are removed as a prop, update isExpanded to be false
    if (isBold && isExpanded && !description && !actions.length) {
      setIsExpanded(false);
    }
  }, [actions.length, description, isBold, isExpanded]);
  useEffect(() => {
    if (!delayAnnouncement) {
      return;
    }
    setTimeout(() => {
      setIsDelayToAnnounce(true);
    }, delayAnnouncement);
  }, [delayAnnouncement]);
  const onFocusAnalytics = usePlatformLeafEventHandler({
    fn: onFocus,
    action: 'focused',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  const onBlurAnalytics = usePlatformLeafEventHandler({
    fn: onBlur,
    action: 'blurred',
    analyticsData: analyticsContext,
    ...analyticsAttributes
  });
  const autoDismissProps = {
    onMouseOver,
    onFocus: onFocusAnalytics,
    onMouseOut,
    onBlur: onBlurAnalytics
  };
  const textColor = flagTextColor[appearance];
  const iconColor = flagIconColor[appearance];
  const iconGlyph = flagIconGlyph[appearance];
  const isDismissable = isBold || isDismissAllowed;
  const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
  const isCollapseAnimationEnabled = fg('platform-dst-flag-collapse-animation-fix');
  // when delayAnnouncement is available we will use a hidden content for announcement
  const delayedAnnouncement = delayAnnouncement ? <VisuallyHidden>
			<MotionPresenceBoundary>
				{title}
				{description}
			</MotionPresenceBoundary>
		</VisuallyHidden> : undefined;

  // A11y improvement opportunity: all flags currently use role="alert" (assertive),
  // but non-critical flags (e.g. info, success) should use role="status" (polite)
  // to avoid interrupting screen reader users. See WCAG 4.1.3.
  return <div role="alert" data-testid={testId} {...autoDismissProps} className={ax(["_39xV02N91d"])}>
			<Box padding="space.200" backgroundColor={flagBackgroundColor[appearance]} xcss={styles.flag}>
				<Inline alignBlock="start" space="space.200">
					<div
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style={({
          [CSS_VAR_ICON_COLOR]: iconColor
        } as CSSProperties)} data-testid={testId && `${testId}-icon-container`} className={ax(["_3iDTPbQ4SZ _4ouGXIoWWg _4kiQYAoWWg _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _1UtDYzGdh0"])}>
						{icon || iconGlyph}
					</div>
					<span className={ax(["_23rrnHoCc6 _4ouGXIdnbC _2O5Vij7dHp"])}>
						<Stack space={shouldRenderGap ? 'space.100' : 'space.0'} // Gap exists even when not expanded due to Expander internals always being in the DOM
          xcss={isCollapseAnimationEnabled ? styles.contentStack : undefined} testId={testId && `${testId}-content-stack`}>
							{/* if isDelayToAnnounce is true, we will use the hidden content for screen reader to announce */}
							{isDelayToAnnounce && delayedAnnouncement}
							<Inline alignBlock="stretch" space="space.100" spread="space-between">
								<Box paddingBlockStart="space.050" paddingBlockEnd="space.025" xcss={styles.overflowWrap}>
									<Heading as={`h${headingLevel}`} size="xsmall" color={textColor}>
										<span
                  /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ aria-hidden={isDelayToAnnounce}>
											<MotionPresenceBoundary>{title}</MotionPresenceBoundary>
										</span>
									</Heading>
								</Box>
								{isDismissable ? !(isBold && !description && !actions.length) && <DismissButton testId={testId} appearance={appearance} isBold={isBold} isExpanded={isExpanded} onClick={isBold ? toggleExpand : buttonActionCallback} /> : null}
							</Inline>
							{/* Normal appearance can't be expanded so isExpanded is always true */}
							<Expander isExpanded={!isBold || isExpanded} testId={testId}>
								{description && <div
              // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
              style={{
                color: flagTextColorToken[appearance]
              }} data-testid={testId && `${testId}-description`}
              /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ aria-hidden={isDelayToAnnounce} className={ax(["_2sNsIgmnOE _4bt5LAIZbP _2WAcuGIZbP _0NUa3rQEt6 _3zvHkHdC7N"])}>
										{description}
									</div>}
								<Actions actions={actions} appearance={appearance} linkComponent={linkComponent} testId={testId} />
							</Expander>
						</Stack>
					</span>
				</Inline>
			</Box>
		</div>;
};
export default Flag;